export function chunk<T>(items: Array<T>, size: number): Array<Array<T>> {
  return items.reduce((result: Array<Array<T>>, _, index) => {
    return index % size === 0
      ? [...result, items.slice(index, index + size)]
      : result;
  }, []);
}

export function chunkRight<T>(items: Array<T>, size: number): Array<Array<T>> {
  const head = items.slice(0, items.length % size);
  const tail = chunk(items.slice(items.length % size, items.length), size);

  return head.length > 0 ? [head, ...tail] : tail;
}
